import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/landingPage/landingPage";
import SuccessPage from "./pages/successPage/successPage";
import NotFoundPage from "./pages/notFoundPage/notFoundPage";
import RecoveryPage from "./pages/recoveryPage/recoveryPage";
import InheritancePage from "./pages/inheritancePage/inheritancePage";
import InheritanceTerminatePage from "./pages/inheritanceTerminatePage/inheritanceTerminatePage";
import ReplacePage from "./pages/replacePage/replacePage";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/encryptString/:encryptString" element={<LandingPage />} />
          <Route path="/response" element={<SuccessPage />} />
          <Route path="/recovery-process/:recoveryString" element={<RecoveryPage />} />
          <Route path="/inheritance-terminate/:terminateString" element={<InheritanceTerminatePage />} />
          <Route path="/inheritance/:inheritanceString" element={<InheritancePage />} />
          <Route path="/replace/:replaceString" element={<ReplacePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
}
export default App;
